'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @module makeStates
 *
 * @description
 *
 * Create SMACSS style state rules.
 * If the correspondent props value is truthy,
 * class with `is-` prefix will be added.
 *
 * Supports `active`, `disabled`, `hidden`, and `loading`.
 *
 * This maker is independent of the value of `block`.
 *
 * *This maker is always applied.*
 *
 * @example
 *
 * import * as pluginStates from 'dumb-bem/lib/plugins/makeStates'
 *
 * pluginStates.maker('block', { active: true }, {})
 *   // => 'is-active'
 *
 * pluginStates.maker('block', { active: 0, disabled: 1 }, {})
 *   // => 'is-disabled'
 *
 * pluginStates.propsToRemove
 *   // => ['active', 'loading']
 *
 */
var maker = exports.maker = function maker(block, props, options) {
  return ['active', 'disabled', 'hidden', 'loading'].filter(function (s) {
    return props[s];
  }).map(function (s) {
    return 'is-' + s;
  });
};

var propsToRemove = exports.propsToRemove = ['active', 'loading'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/dumb-bem/lib/plugins/makeStates.js
// module id = 1220
// module chunks = 0